import React, { FC, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { baseUrl, GetToken } from "../App";

type Props = {
  displayModal: boolean;
  handleDownload: () => void;
  closeShow: () => void;
};

export const RoadMapModal: FC<Props> = ({
  displayModal,
  closeShow,
  handleDownload,
}) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState<{ firstName?: string; lastName?: string; email?: string }>({});
  const [loading, setLoading] = useState(false);

  const fetchPDFDetails = async () => {
    try {
      let idToken = await GetToken();

      const response = await axios.get(
        `${baseUrl}/roadmap-details`,
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      );

      if (response.data && response.data.filename && response.data.pdfBase64) {
        return response.data;
      } else {
        throw new Error("Invalid response from backend");
      }
    } catch (error) {
      console.error("Error fetching PDF details:", error);
      toast.error("Failed to fetch roadmap. Please try again.");
      return null;
    }
  };

  const sendEmail = async () => {
    setLoading(true);
    setError({});

    if (!firstName || !lastName || !email) {
      setError({
        firstName: !firstName ? "First name is required" : undefined,
        lastName: !lastName ? "Last name is required" : undefined,
        email: !email ? "Email is required" : undefined,
      });
      setLoading(false);
      return;
    }

    try {
      const pdfData = await fetchPDFDetails();
      if (!pdfData) {
        setLoading(false);
        return;
      }

      const { filename, pdfBase64 } = pdfData;
     

      const bodyData = {
        sender: { email: "info@doyenify.com", name: "Doyenify Academy" },
        to: [{ email }],
        replyTo:{
          email:"info.doyenify@gmail.com",
        },
        subject: `${filename} PDF !`,
        htmlContent: `
          <div style="font-family: Arial, sans-serif; max-width: 600px; margin: auto; padding: 20px; border-radius: 10px; background-color: #ffffff; border: 1px solid #ddd;">
                      <div style="display: flex; justify-content: center; align-items: center; margin-left: 35%; text-align: center; width: 100%; padding: 20px;">
  <img src="https://academy.doyenify.com/images/doyenifyAcademy.png" alt="DoyenifyAcademy Logo" style="max-width: 100%; height: auto; display: block;" />
</div>

            <h2 style="color: #047711; text-align: center;">Hello ${firstName},</h2>
      
            <p style="font-size: 16px; text-align: center; color: #444;">
              Thank you for requesting the <strong>${filename}</strong>. <br/>
               Below is the pdf attachment.
            </p>
      
       
            <p style="font-size: 14px; text-align: center; color: #666;">
              If you have any questions, feel free to reply to this email. <br/>
              We're here to help!
            </p>
      
            <hr style="border: none; border-top: 1px solid #ddd; margin: 20px 0;">
      
            <!-- Footer -->
            <p style="font-size: 13px; text-align: center; color: #999;">
              &copy; ${new Date().getFullYear()} <strong>DoyenifyAcademy</strong>. All rights reserved.
            </p>
      
          </div>
        `,
        attachment: [
          {
            content: pdfBase64,
            name: filename,
            type: "application/pdf",
          },
        ],
      };
      
      let idToken = await GetToken();
      const response = await axios.post(`${baseUrl}/adduser-roadmap`, {
        firstName,
        lastName,
        email,
        downloadedfile: filename,
      },{
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }  );
    
      if (response.data) {
         const responseToken = await fetch("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
          process.env.REACT_APP_SERVICE_KEY, {
          method: "post",
          body: JSON.stringify({
            email: process.env.REACT_APP_SERVICE_EMAIL,
            password: process.env.REACT_APP_SERVICE_PASSWORD,
            returnSecureToken: true,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        });

        const userToken = await responseToken.json();
        await axios
        .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodyData, {
            headers: { Authorization: `Bearer ${userToken.idToken}` },
          }
        )
        .then(() => {
          toast.success("Email sent successfully!");

          setFirstName("");
          setLastName("");
          setEmail("");
          handleDownload();
        })
        .catch(() => {
          console.log("(axios) an error occurred")
          toast.error("Failed to send email. Please try again.");
        });

        

      } else {
        toast.error("Failed to send email. Please try again.");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    closeShow();
  };

  if (!displayModal) return null;

  return (
    <div className="fixed z-[999] inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4">
      <ToastContainer autoClose={1000} />
      <div className="bg-white max-w-[700px] rounded-[20px] shadow-lg w-[95%] sm:w-full md:w-[600px] max-h-[90vh] overflow-auto relative">
        <div className="rounded-t-[20px] p-6 h-[60px] bg-[#047711] flex items-center justify-center">
          <h2 className="text-[14px] px-4 text-center sm:text-[17px] md:text-[20px] lg:text-[26px] xl:text-[26px] font-[800] text-white">
          kindly input your details to download roadmap
          </h2>
        </div>

        <button onClick={handleClose} className="absolute top-3 pr-3 right-3 text-[#ffffff] text-lg">
          ✖
        </button>

        <div className="flex flex-col justify-center items-center gap-6 font-[600] text-[15px] py-10 m-auto">
          <div className="grid grid-cols-2 gap-4 w-full max-w-[600px] sm:max-w-[300px] md:max-w-[400px]">
            <div>
              <label htmlFor="FirstName">First name</label>
              <input
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="w-full h-[42px] p-3 bg-[#F2FFD8] border-[1px] border-[#0F7D1A] rounded-[8px]"
                type="text"
                placeholder="First name"
              />
              {error.firstName && <p className="text-red-500 text-sm">{error.firstName}</p>}
            </div>
            <div>
              <label htmlFor="LastName">Last name</label>
              <input
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className="w-full h-[42px] p-3 bg-[#F2FFD8] border-[1px] border-[#0F7D1A] rounded-[8px]"
                type="text"
                placeholder="Last name"
              />
              {error.lastName && <p className="text-red-500 text-sm">{error.lastName}</p>}
            </div>
          </div>

          <div className="w-full max-w-[600px] sm:max-w-[300px] md:max-w-[400px]">
            <label htmlFor="email">Email</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-[42px] p-3 bg-[#F2FFD8] border-[1px] border-[#0F7D1A] rounded-[8px]"
              type="text"
              placeholder="Email"
            />
            {error.email && <p className="text-red-500 text-sm">{error.email}</p>}
          </div>

          <div className="w-full max-w-[600px] sm:max-w-[300px] md:max-w-[400px]">
            <button
              onClick={sendEmail}
              disabled={loading}
              className={`py-2 rounded-[8px] no-underline w-full text-[20px] font-[600] ${
                loading ? "bg-gray-400 cursor-not-allowed" : "bg-[#0F4B16] text-white"
              }`}
            >
              {loading ? "Sending..." : "Download Roadmap"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
